import React, { useContext, useEffect, useState } from 'react'
import globalRothStyles from "../../../../Styles/ComponentStyles/ProfileStyle/ProfileRothConversion/ProfileRothConversionIndex.module.scss"
import globalStyles from '../../../../Styles/ComponentStyles/global.module.scss';

import { Grid, useMediaQuery } from '@mui/material'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import RothAccountValue from './ProfileRothConversionTabs/RothAccountValue';
import RothRetirementIncome from './ProfileRothConversionTabs/RothRetirementIncome';
import RothTaxes from './ProfileRothConversionTabs/RothTaxes';
import CustomNumberTextField from '../../../../GlobalComponent/CustomNumberTextField/CustomNumberTextField';
import QuickRothConversionDioalog from './QuickRothConversionDioalog';
import GlobalDraggableDialog from '../../../../GlobalComponent/GlobalDraggableDialog/GlobalDraggableDialog';
import GlobalTabsComponent from '../../../../GlobalComponent/GlobalTabsComponent/GlobalTabsComponent';
import { ProfileContext, ProfileContextPayload } from '../../../../Context/ProfileDetailsContext';

function ProfileRothConversionIndex() {

    const {
        profileRothConversionDetails,
        flagOpenQuickEditDialog, setFlagOpenQuickEditDialog,
    } = useContext(ProfileContext) as ProfileContextPayload
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isBelow591 = useMediaQuery('(max-width:591px)')

    const queryParams = new URLSearchParams(location.search);
    const initialTabValue = queryParams.get('tab') || '1';
    const [minAge, setMinAge] = useState<number>(0);
    const [maxAge, setMaxAge] = useState<number>(0);
    const [tabNavigationValue, setTabNavigationValue] = useState<string>(initialTabValue);
    const [selectedAge, setSelectedAge] = useState<number>(0);

    useEffect(() => {
        if (profileRothConversionDetails) {
            const yearlyBreakdown = profileRothConversionDetails?.data[0]?.yearly_breakdown || {};
            const ageKeys = Object.keys(yearlyBreakdown).map(Number);
            if (ageKeys.length > 0) {
                const min = Math.min(...ageKeys);
                const max = Math.max(...ageKeys);
                setMinAge(min);
                setMaxAge(max);
            }
        }
    }, [profileRothConversionDetails])

    useEffect(() => {
        const updatedTab = new URLSearchParams(location.search).get('tab') || '1';
        setTabNavigationValue(updatedTab);
    }, [location.search]);

    useEffect(() => {
        if (minAge > 0) {
            setSelectedAge(minAge);
        }
    }, [minAge]);

    const renderTabContent = () => {
        switch (tabNavigationValue) {
            case '1':
                return (<RothAccountValue selectedAge={selectedAge} />);
            case '2':
                return (<RothTaxes selectedAge={selectedAge} />);
            case '3':
                return (<RothRetirementIncome selectedAge={selectedAge} />);
            default:
                return (<RothAccountValue selectedAge={selectedAge} />);
        }
    };

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabNavigationValue(newValue);

        const params = new URLSearchParams(location.search);
        const userId = params.get('user_id');
        navigate(`${location.pathname}?user_id=${userId}&tab=${newValue}`);
    };

    const onClose = () => {
        setFlagOpenQuickEditDialog(false)
    }

    const modalIsOpen = () => {
        setFlagOpenQuickEditDialog(true)
    }

    const isInputBetween = (num1: any, num2: any, value: any) => value > num1 && value < num2;

    const inputBlureChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(minAge), Number(maxAge), val)
        if (checkInBeetween == false) {
            if (val >= Number(maxAge))
                setSelectedAge(Number(maxAge))
            else {
                setSelectedAge(Number(minAge))
            }
            return
        }
    }

    return (
        <>
            <Grid container>
                {flagOpenQuickEditDialog &&
                    <GlobalDraggableDialog
                        onClose={onClose}
                        modalIsOpen={modalIsOpen}
                        className={globalRothStyles.profileGlobalDraggableDialog}
                        children={<QuickRothConversionDioalog />}
                    />
                }

                <Grid item xs={12}
                    // className={styles.globalBlurWrapperForOutput}
                    sx={{
                        minHeight: "calc(100vh - 100px)",
                        backgroundColor: "#FBFCFD !important",
                    }}
                >
                    <Grid container>
                        <Grid item xs={12} className={globalRothStyles.gblRothCardsItem}>
                            <Grid container>
                                <Grid item xs={12}
                                    sx={{
                                        backgroundColor: "#fff",
                                        padding: "0px 20px",
                                        borderBottom: "1px solid #E2E8F0"
                                    }}>
                                    <Grid container sx={{ justifyContent: "space-between" }} gap={`${isBelow591 ? "20px" : "0px"}`}>
                                        <Grid item className={globalRothStyles.tabsWrapper}>
                                            <GlobalTabsComponent
                                                value={tabNavigationValue}
                                                onChange={handleTabChange}
                                                normalColor="#45556C"
                                                selectedColor="#04385D"
                                                indicatorColor="#04385D"
                                                tabs={[
                                                    { label: "Account Value", value: "1" },
                                                    { label: "Taxes", value: "2" },
                                                    { label: "Retirement Income", value: "3" },
                                                ]}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={globalRothStyles.rothCardAgeComponentItem}>
                                    <CustomNumberTextField
                                        type="number"
                                        size="small"
                                        variant="outlined"
                                        value={isNaN(selectedAge) ? '' : selectedAge}
                                        onChange={(e) => {
                                            const value = e?.target?.value;

                                            if (value === '') {
                                                setSelectedAge(NaN); // Or just '' if you're okay with a string state temporarily
                                                return;
                                            }

                                            const numericValue = Number(value);
                                            // if (numericValue >= minAge && numericValue <= maxAge) {
                                            setSelectedAge(numericValue);
                                            // }
                                        }}
                                        InputProps={{ inputProps: { min: minAge, max: maxAge } }}
                                        onBlur={inputBlureChangeYear}
                                        customStyles={{
                                            backgroundColor: "white",
                                            color: "black"
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    {renderTabContent()}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ProfileRothConversionIndex